import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import {
  Avatar,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { CloudDownload, Delete, FontDownload, Image, InsertDriveFile, MoreVert, Videocam } from '@material-ui/icons';
import {
  ClassAttributes,
  createElement,
  createRef,
  Fragment,
  MouseEvent,
  MouseEventHandler,
  PureComponent,
  RefObject,
} from 'react';
import { FormattedMessage } from 'react-intl';

import FileSize from '../../primitive/FileSize';

export type Props = ClassAttributes<HTMLElement> & {
  file: FileReference;
  isVisibleSecondary?: boolean;
  onClickDeleteButton?: MouseEventHandler<HTMLElement>;
  className?: string;
};

type State = {
  isVisibleSecondary: boolean;
  isMenuOpen: boolean;
};

class FileListItem extends PureComponent<Props, State> {
  private readonly menuButton: RefObject<HTMLElement>;

  public state: State = {
    isVisibleSecondary: this.props.isVisibleSecondary !== undefined ? this.props.isVisibleSecondary : true,
    isMenuOpen: false,
  };
  public render() {
    let Icon = InsertDriveFile;

    if (this.props.file.mimetype.startsWith('image/')) {
      Icon = Image;
    } else if (this.props.file.mimetype.startsWith('video/')) {
      Icon = Videocam;
    } else if (this.props.file.mimetype.startsWith('font/')) {
      Icon = FontDownload;
    }

    return (
      <Fragment>
        <ListItem className={this.props.className}>
          <ListItemIcon>
            <Avatar>
              <Icon />
            </Avatar>
          </ListItemIcon>

          <ListItemText
            primary={
              <OriginalName variant="subtitle1" noWrap>
                {this.props.file.originalName}
              </OriginalName>
            }
            secondary={
              this.state.isVisibleSecondary ? (
                <Typography variant="body1" color="textSecondary" noWrap>
                  <FileSize fileSize={this.props.file.size}>
                    {(fileSize) => `${fileSize} - ${this.props.file.createdAt.toFormat('yyyy-MM-dd HH:mm:ss')}`}
                  </FileSize>
                </Typography>
              ) : null
            }
            disableTypography
          />

          <ListItemSecondaryAction>
            <IconButton component="a" href={this.props.file.url}>
              <CloudDownload />
            </IconButton>

            {this.props.onClickDeleteButton ? (
              <IconButton onClick={this.onClickMenuButton} buttonRef={this.menuButton}>
                <MoreVert />
              </IconButton>
            ) : null}
          </ListItemSecondaryAction>
        </ListItem>

        {this.props.onClickDeleteButton ? (
          <Menu anchorEl={this.menuButton.current!} open={this.state.isMenuOpen} onClose={this.onRequestCloseMenu}>
            <MenuItem onClick={this.onClickDeleteButton}>
              <ListItemIcon>
                <Delete />
              </ListItemIcon>

              <FormattedMessage id="file_list.file_list_item.delete">
                {(label: string) => <ListItemText inset primary={label} />}
              </FormattedMessage>
            </MenuItem>
          </Menu>
        ) : null}
      </Fragment>
    );
  }

  private onClickMenuButton = () => this.setState({ isMenuOpen: true });

  private onRequestCloseMenu = () => this.setState({ isMenuOpen: false });

  private onClickDeleteButton = (e: MouseEvent<HTMLElement>) => {
    this.onRequestCloseMenu();

    this.props.onClickDeleteButton!(e);
  };

  public constructor(props: Props) {
    super(props);

    this.menuButton = createRef();
  }
}

const OriginalName = styled(Typography)<{
  moreButton?: boolean;
}>(({ moreButton }) => ({
  paddingRight: moreButton ? 48 : 0,
}));

export default FileListItem;
